export const PASSIONS = [
  'Ads & Marketing',
  'Architecture',
  'Creative lifestyle',
  'Design & Art',
  'Fashion & Styling',
  'Game',
  'Manufacturing',
  'Mod & Crafts',
  'Music & Audio',
  'Photography',
  'Road vehicles',
  'Software & Programming',
  'Storytelling',
  'Tech & Innovation',
  'Video & Animation',
  'Writing & Publishing',
];

export const SKILLS = {
  'Ads & Marketing': [
    'Advertisement',
    'Branding',
    'Copywriting',
    'Crowdfunding Camapign Creation',
    'Crowdfunding Campaign Marketing',
    'Digital marketing',
    'Exhibition Design',
    'PPL',
    'PR',
    'Review',
    'Unboxing',
  ],
  Architecture: [
    'Drawing and Rendering',
    'Interior Design',
    'Landscape Design',
  ],
  'Creative lifestyle': [
    'Cap',
    'Custom Printing',
    'Custom T-Shirt',
    'Fan Merch',
    'Stationary',
    'Toys And Collectible',
  ],
  'Design & Art': [
    'Automotive Design',
    'BX/BI',
    'Calligraphy',
    'Cartoon',
    'Character Design',
    'Comic Strip',
    'Drawing',
    'Fashion',
    'Fine Art',
    'Game',
    'Graffiti And Street Art',
    'Graphic Design',
    'Icon Design',
    'Illustration',
    'Industrial Design',
    'Interaction Design',
    'Packaging',
    'Painting',
    'Print Design',
    'Product Design',
    'Storyboard Drawing',
    'Street Art',
    'Typography',
    'UX/UI',
  ],
  'Fashion & Styling': [
    'Accessories',
    'Clothing',
    'Fashion Bag',
    'Fashion Luggage',
    'Fashion Shoes',
    'Watch',
  ],
  Game: [
    'Board Game',
    'Equipment Design',
    'Game Art',
    'Game Character',
    'Game Writing',
    'Gaming Merch',
    'Level Design',
    'Minecraft',
    'Video Game',
  ],
  Manufacturing: [
    'Build On Demand',
    'Manufacturability',
    'OEM/ODM',
    'On-Demand 3D Printing',
    'Print On Demand',
    'Prototyping Service',
  ],
  'Mod & Crafts': [
    '3D Printing Craft',
    'Car Mod',
    'Case Mod',
    'Crafts',
    'DIY Hack',
    'LEGO',
    'Furniture',
    'IKEA Hack',
    'Machinery',
    'PC Mod',
    'Product Prototyping',
  ],
  'Music & Audio': [
    'Beatbox',
    'Busking',
    'Compose',
    'Electronic Music',
    'Instruments',
    'Music Producing',
    'Podcast',
    'Remix',
    'Sound Design',
    'Studio Session',
    'Vocal',
  ],
  Photography: [
    'Architecture',
    'Nature',
    'Photography',
    'Portrait',
    'Street',
    'Studio',
  ],
  'Road vehicles': [
    'Bicycle',
    'Car Design',
    'Car Tuning',
    'Scooter',
    'Electric Vehicle',
    'Motor Bike',
  ],
  'Software & Programming': [
    'AI',
    'AR/VR',
    'Biochemical Programming',
    'Blockchain',
    'E-commerce',
    'FinTech',
    'Frontend Development',
    'Backend Development',
    'IoT',
    'Machine Learning',
    'Mobile App',
    'Programming',
    'DevOps',
    'Software Prototyping',
    'Web Development',
    'Wordpress',
  ],
  Storytelling: [
    'Audio Book',
    'Brand Story',
    'Character Development',
    'Comics',
    'Crowdfunding Pitch',
    'E-Book',
    'Podcasts',
    'YouTube',
    'Sci-Fi',
    'Storyboarding',
  ],
  'Tech & Innovation': [
    '3D Printing Tech',
    'Audio',
    'Coffee Maker',
    'Display',
    'Electric Cars',
    'Electric Scooter',
    'Gaming Devices',
    'Health And Fitness Innovation',
    'Innovative Bags',
    'Innovative Bicycle',
    'Innovative Motor Bike',
    'Innovative Kitchenware',
    'Innovative Luggage',
    'Innovative Shoes',
    'PC, Laptop And Tablets',
    'Personal Care',
    'Personal Mobility',
    'Tech Accessories',
    'Travel And Outdoors',
    'VR',
  ],
  'Video & Animation': [
    'Animation',
    'Branding Video',
    'Crowdfunding Video',
    'Documentary',
    'Drone',
    'Film And Movie',
    'Interview',
    'Motion Comics',
    'Motion Graphics',
    'Music Video',
    'Product Review Video',
    'Product Video',
    'Unboxing Video',
    'Vlog',
  ],
  'Writing & Publishing': [
    'Advertorial',
    'Book',
    'Editorial And Journalism',
    'Essay And Blog',
    'Fiction',
    'Magazine',
    'Non-Fiction',
    'Product Review Blog',
    'Translation',
    'Unboxing Blog',
  ],
} as const;

export const skillOptions = Object.keys(SKILLS)
  .reduce(
    (options, key) => [
      ...options,
      SKILLS[key].map((skill) => ({ label: skill, value: skill })),
    ],
    []
  )
  .flat()
  .sort((a, b) => a.label.localeCompare(b.label));
